<template>
    <div class="Field form-group">
        <slot name="label">
            <label :for="name" class="form-control-label">{{ label }}
                <span v-if="required" class="text-danger">*</span>
            </label>
        </slot>
        <slot :classes="classes" :error="resolvedError"></slot>
        <div v-if="!!resolvedError || $slots.error" class="invalid-feedback d-block">
            <slot name="error">
                {{ resolvedError }}
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'field',
        inject: {
            form: {
                default: null,
            },
        },
        props: {
            name: String,
            error: String,
            label: String,
            required: Boolean
        },
        data() {
            return {
                localError: null,
                cleaned: false
            }
        },
        computed: {
            classes() {
                return {
                    'is-invalid': !!this.resolvedError
                }
            },
            resolvedError() {
                return this.localError || (!this.cleaned && this.error)
            },
        },
        methods: {
            // used by injected form
            setError(error) {
                if(error) {
                    this.localError = error;
                }
            },
            // used by injected form
            clear() {
                this.localError = null;
            }
        },
        mounted() {
            if(this.form) {
                this.form.registerField(this);
            }
        },
        destroyed() {
            if(this.form) {
                this.form.unregisterField(this);
            }
        }
    }
</script>